import Save from '@mui/icons-material/Save';
import { useState } from 'react';

import { GridBlockType } from 'services/entities/BlockTypes';
import { SaveAssetToLibraryDialog } from 'components/library/snippets/SaveSnippetDialog';
import { useBlockContent } from '../../Sections/useBlockContent';
import BlockSettingsToolButton from './BlockSettingsToolButton';
import { useBlockLockStatus } from '../../hooks/useBlockLockStatus';
import { useComments } from 'providers/CommentsContext';

export interface AssetSaveToolProps {
  blockId: string;
}
export default function AssetSaveTool({ blockId }: AssetSaveToolProps) {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const blockContent = useBlockContent(blockId);
  const { isLocked } = useBlockLockStatus(blockId);
  const { commentsEnabled: commentsEnabledFromContext } = useComments();

  const handleSave = () => {
    setIsDialogOpen(true);
  };

  const handleClose = () => {
    setIsDialogOpen(false);
  };

  if (blockContent?.type !== GridBlockType.TEXT) {
    return null;
  }

  if (isLocked) {
    return null;
  }

  if (commentsEnabledFromContext) {
    return null;
  }

  let isDisabled = true;

  if (blockContent?.content) {
    try {
      const parsed = JSON.parse(blockContent.content);
      isDisabled = !parsed?.content?.[0]?.content;
    } catch {
      isDisabled = blockContent.content.trim() === '';
    }
  }

  return (
    <>
      <BlockSettingsToolButton title="Create a new snippet" onClick={handleSave} disabled={isDisabled}>
        <Save width={24} height={24} fontSize="small" color="inherit" />
      </BlockSettingsToolButton>
      <SaveAssetToLibraryDialog isOpen={isDialogOpen} onClose={handleClose} blockId={blockId} />
    </>
  );
}
